// extracted by mini-css-extract-plugin
export default {"flexBox":"TicketDetails_flexBox__qsqMP","heading":"TicketDetails_heading__75zyD"};